export const rolesPage1 = {
  message: 'OK',
  data: [
    {
      id: '3',
      label: 'Administrador'
    },
    {
      id: '4',
      label: 'Cliente'
    },
    {
      id: '2',
      label: 'Cobranza'
    },
    {
      id: '5',
      label: 'Empleado'
    },
    {
      id: '1',
      label: 'Gerente'
    }
  ]
}
